import { createFileRoute, notFound } from "@tanstack/react-router";
import { MarketingIdeasPage } from "../components/marketing/MarketingIdeasPage";
import { findIdeaHub, ideaHubPage } from "../marketing-content/automationIdeaHubs";
import { contentHead } from "../marketing-content/head";

export const Route = createFileRoute("/workflows_/industry/$industry")({
  loader: ({ params }) => {
    const hub = findIdeaHub("industry", params.industry);
    if (!hub) throw notFound();
    return hub;
  },
  head: ({ loaderData }) => contentHead(loaderData && ideaHubPage(loaderData)),
  component: HubRoute,
});

function HubRoute() {
  const hub = Route.useLoaderData();
  return <MarketingIdeasPage hub={hub} key={hub.slug} />;
}
